
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fullcoveragewarranty/[category]",
      function () {
        return require("private-next-pages/fullcoveragewarranty/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fullcoveragewarranty/[category]"])
      });
    }
  